<template>
  <b-card>
    <div class="row">
      <div class="col-6 d-flex align-items-center justify-content-lg-start">
        <Button
          v-if="showBackButton && actionType === 'save' || 'add'"
          :label="$t('List page')"
          size="md"
          icon="ArrowLeftIcon"
          show-icon
          class="mb-1"
          @click="backNavigationAction"
        />
      </div>
      <div class="col-6 d-flex justify-content-end">
        <Button
          v-if="showSearchButton"
          :label="$t('Search')"
          size="md"
          icon="SearchIcon"
          show-icon
          @click="showSearchField"
        />
      </div>
    </div>
    <b-row class="position-relative">
      <b-col
        v-if="!showSearchButton"
        md="4"
      >
        <b-row>
          <Alert
            :show="showFormErrorAlert"
            :message="$t('Customer\'s account name, account number, or customer ID is required')"
          />
          <b-col md="12">
            <InputField
              id="customer-id"
              v-model="searchParams.customerID"
              :label="$t('Customer ID')"
              :placeholder="$t('Enter customer Id')"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="account-number"
              v-model="searchParams.accountNumber"
              :label="$t('Account Number')"
              :placeholder="$t('Enter account number')"
              type="number"
            />
          </b-col>

          <b-col md="12">
            <InputField
              id="account-name"
              v-model="searchParams.accountName"
              :label="$t('Account Name')"
              :placeholder="$t('Enter account name')"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <Button
              :label="$t('Search')"
              size="md"
              class="mt-2"
              block
              @click="handleSearch"
            />
          </b-col>
        </b-row>

      </b-col>
      <b-col
        v-if="showSearchButton"
        :md="showSearchButton === true ? '12' : '8'"
      >
        <div v-if="showCustomerInfo">
          <validation-observer ref="accountMemoRules">
            <app-collapse
              class="business-items mb-4"
              type="margin"
              accordion
            >
              <app-collapse-item
                :title="$t('Account Summary')"
                class="card-item"
                is-visible
              >
                <b-row>
                  <b-col md="4">
                    <InputField
                      id="account-name"
                      v-model="customer.accountName"
                      :label="$t('Account Name')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="account-number"
                      v-model="customer.accountNumber"
                      :label="$t('Account Number')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="product-name"
                      v-model="customer.productName"
                      :label="$t('Product Name')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="NUBAN"
                      v-model="customer.accountNumber"
                      label="NUBAN"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="branch"
                      v-model="customer.branchName"
                      :label="$t('Branch')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="account-status"
                      v-model="customer.accountStatus"
                      :label="$t('Account Status')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="ledger-balance"
                      v-model="customer.ledgerBalance"
                      :label="$t('Ledger Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="available-balance"
                      v-model="customer.availableBalance"
                      :label="$t('Available Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="withdrawable-balance"
                      v-model="customer.withdrawableBalance"
                      :label="$t('Withdrawable Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                </b-row>
              </app-collapse-item>
            </app-collapse>

            <h5 class="text-capitalize mb-3">
              {{ $t('ADD MEMO') }}
            </h5>
            <b-row>
              <b-col md="6">
                <SelectField
                  id="action-type"
                  v-model="accountMemoFormData.actionType"
                  :label="$t('Action Type')"
                  rules="required"
                  :error-name="$t('Action Type')"
                  :reduce="option => option.value"
                  :options="memoAccountActionTypesOptions"
                  item="label"
                  :placeholder="$t('Select Action Type')"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="reasons"
                  v-model="accountMemoFormData.details"
                  :label="$t('Reason')"
                  rules="required"
                  :error-name="$t('Reason')"
                  :reduce="option => option.value"
                  :options="memoAccountReasonsOptions"
                  item="label"
                  :placeholder="$t('Select Reason')"
                />
              </b-col>
              <b-col md="6">
                <TextAreaField
                  id="comments"
                  v-model="accountMemoFormData.comments"
                  :label="$t('Comments')"
                  :placeholder="$t('Enter comments')"
                  rows="1"
                />
              </b-col>
            </b-row>
          </validation-observer>
          <div class="button-center mt-5">
            <div>
              <Button
                :label="$t('Submit')"
                :loading="isLoading"
                size="lg"
                @click="handleSubmit"
              />
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-modal
      id="search-modal"
      ref="search-modal-lg"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Customer Details')"
      cancel-title-only
      @hidden="resetModal"
    >

      <b-table
        ref="customerListTable"
        select-mode="single"
        :items="customerList"
        responsive
        :fields="translatedTableHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >

        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>

    </b-modal>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>

import {
  BCard, BRow, BCol, BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { tableMixins } from '@core/mixins/table'
import { mapActions, mapGetters } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { accountPermissions } from '@/helpers/permissions'
import TablePagination from '@/views/components/table/TablePagination.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toBalance } from '@/helpers/formatAmount'
import { memoAccountActionTypes, memoAccountReasons } from '@/helpers/data'
import InputField from '../../../../forms/InputField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import TextAreaField from '../../../../forms/TextAreaField.vue'
import Button from '../../../../components/button/Button.vue'
import Alert from '../../../../components/alert/Alert.vue'

export default {
  components: {
    BRow,
    BCol,
    InputField,
    SelectField,
    TextAreaField,
    Button,
    TablePagination,
    Alert,
    BTable,
    BCard,
    FullScreenSpinner,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [sweetAlert, tableMixins, modalMixins],
  data() {
    return {
      actionType: 'save',
      isDisabled: false,
      isLoading: false,
      showFormErrorAlert: false,
      showCustomerInfo: false,
      showSearchButton: false,
      showBackButton: false,
      isEditable: true,
      required,
      positive,
      showSpinner: false,
      sortDesc: false,
      currentPage: 1,
      perPage: 10,
      sortBy: 'accountName',
      searchParams: {
        accountNumber: null,
        accountName: null,
        customerID: null,
      },
      accountMemoFormData: {
        actionType: '',
        details: '',
        comments: '',
      },

      customerList: [],
      customer: {
        accountName: '',
        accountNumber: '',
        productName: '',
        branchName: '',
        accountStatus: '',
        ledgerBalance: '',
        availableBalance: '',
        withdrawableBalance: '',
        originalLedgerBalance: 0,
      },
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
      ],
    }
  },
  computed: {
    totalEntries() {
      return this.customerList.length
    },
    numberOfPages() {
      return Math.floor((this.totalEntries + this.perPage - 1) / this.perPage)
    },
    from() {
      return (this.currentPage * this.perPage) - (this.perPage - 1)
    },
    to() {
      return Math.min(this.from + this.perPage - 1, this.totalEntries)
    },
    ...mapGetters({
      userDetails: 'auth/getCurrentUser',
    }),
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    memoAccountReasonsOptions() {
      return memoAccountReasons.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
    memoAccountActionTypesOptions() {
      return memoAccountActionTypes.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
  },
  methods: {
    ...mapActions({
      searchCustomerAccount: 'account/searchCustomerAccountAction',
      accountMemoCreate: 'account/accountMemoCreateAction',
      getUserBalance: 'account/getCASABalanceAction',
    }),
    async handleSearch() {
      try {
        const isSearchParamsNotEmpty = Object.values(this.searchParams).every(params => (params === null || params === ''))
        if (!isSearchParamsNotEmpty) {
          this.showFormErrorAlert = false
          this.showSpinner = true
          const response = await this.searchCustomerAccount({
            search: this.searchParams,
            page: this.currentPage,
            limit: this.perPage,
            permission: 'VIEW_MEMO',
          })
          const { status, data } = response
          if (status === 200 && data?.data) {
            this.customerList = data.data
            this.totalCount = data.recordCount
            this.showSpinner = false
            this.$root.$emit('bv::show::modal', 'search-modal')
          } else {
            this.customerList = []
            this.totalCount = data.recordCount
            this.$root.$emit('bv::show::modal', 'search-modal')
          }
        } else {
          this.showFormErrorAlert = true
          this.showSpinner = false
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async onSelectCustomer(items) {
      try {
        const [customer] = items
        this.hideModal('search-modal')
        this.showSpinner = true
        this.showBackButton = true
        const response = await this.getUserBalance({ accountNumber: customer.accountNumber, permission: 'VIEW_MEMO' })
        const { data, status } = response
        if (status === 200) {
          this.customer = {
            ...customer,
            availableBalance: toBalance(data.availableBalance),
            withdrawableBalance: toBalance(data.withdrawableBalance),
            ledgerBalance: toBalance(data.ledgerBalance),
            originalLedgerBalance: data.ledgerBalance,
          }
          if (data.accountStatus === 'Closed') {
            const closedText = this.$t('has been closed')
            this.alertError({ text: `${data.accountName} - ${data.accountNumber} ${closedText}.` })
            this.isDisabled = true
          }
        }
        this.showCustomerInfo = true
        this.showSearchButton = true
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async handleSubmit() {
      this.$refs.accountMemoRules.validate().then(success => {
        if (success) {
          const textQuestion = this.$t('Are you sure you want to create memo on this account')
          this.confirm(this.createAccountMemoAction, { text: `${textQuestion}: ${this.customer.accountNumber} ?` })
        }
      })
    },
    async createAccountMemoAction() {
      try {
        this.isLoading = true
        this.isDisabled = true

        const formData = {
          accountNumber: this.customer.accountNumber,
          actionType: this.accountMemoFormData.actionType,
          details: this.accountMemoFormData.details,
          comments: this.accountMemoFormData.comments,
          initiatedBy: this.userDetails.email,
        }
        const response = await this.accountMemoCreate({ formData, permission: accountPermissions.ADD_MEMO })

        const { status, data } = response
        if (status === 200 && data) {
          this.showCustomerInfo = false
          this.isLoading = false
          this.isDisabled = false
          this.resetInputField()
          this.resetSearchParams()
          this.alertSuccess({ text: this.$t('Your Memo request was successful') })
          this.$router.push('memo-management')
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    resetInputField() {
      this.searchParams = { ...null }
      this.accountMemoFormData = { ...null }
      this.customer = { ...null }
      this.isLoading = false
      this.isDisabled = false
      this.showCustomerInfo = false
      this.showSearchButton = false
      this.showBackButton = false
    },
    showSearchField() {
      this.showSearchButton = false
      this.resetSearchParams()
    },
    resetSearchParams() {
      this.searchParams.accountNumber = null
      this.searchParams.accountName = null
      this.searchParams.customerID = null
    },
    resetModal() {
      this.customerList = []
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: 'memo-management',
      })
    },
  },
}
</script>
<style scoped>
 [dir] .demo-inline-spacing > *, .custom-control , .custom-control-inline, .custom-checkbox {
    margin-top: 0rem !important;
}
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem
}

.button-center {
  display: flex;
  justify-content: center;
}
</style>
